export default __webpack_public_path__ + "static/media/LNG.bdf7f3aa.svg";